import React, { Component, Fragment } from 'react';
import i18n from "../../../../../../constants/initLng";
import Input from '../../../../common/component/Input';
import Switch from '../../../../common/component/Switch';
import * as HMS from '../../../../common/component/Index';
import * as Func from '../../../../../../helpers/functions';
import './style.less';
import { DETAIL_ACTIONS } from '../../../../../../constants/Define';
import AntSelect, { AntOption } from '../../../../common/component/AntSelect';
import Wrapper from '../../../../common/component/Wrapper';

export default class ExtendInfo extends Component {

    constructor(props) {
        super(props);
        this.state = {
            amenities: [],
            dataAmenity: []
        }
    }

    static getDerivedStateFromProps(props, state) {
        if (props.amenities !== state.amenities) {
            const newAmenities = props.amenities.filter(item => item.isActive)
            const newhomestayRoomTypeAmenity = props.homestayRoomType.amenity.filter(item => newAmenities.find(i => i.id === item))
            return {
                amenities: newAmenities,
                dataAmenity: newhomestayRoomTypeAmenity
            };
        }
        return null;
    }

    render() {
        const { loading, homestayRoomType, action } = this.props;
        const { amenities, dataAmenity } = this.state;

        return (
            <div className="extend-info">
                <div className="extend-info-box">
                    <h3>{i18n.t(`item.homestayRoomType.extend_info`)}</h3>
                    <div className="row">
                        <div className="form-group col-md-6">
                            <HMS.FormWrapperInputComponent
                                isRequired={false}
                                isValidation={false}
                                labelTitle={i18n.t(`item.homestayRoomType.refId`)}
                                visible={action !== DETAIL_ACTIONS.TRANSLATE}
                            >
                                <Input
                                    disabled={true}
                                    onChange={this.props.onChange}
                                    name={`refId`}
                                    value={homestayRoomType.refId}
                                    placeholder={i18n.t('item.homestayRoomType.refId')} />
                            </HMS.FormWrapperInputComponent>
                        </div>
                        <div className="form-group col-md-6">
                            <HMS.FormWrapperInputComponent
                                isRequired={false}
                                isValidation={false}
                                labelTitle={i18n.t(`item.homestayRoomType.isActive`)}
                                visible={action !== DETAIL_ACTIONS.TRANSLATE}
                            >
                                <br />
                                <Switch defaultChecked={homestayRoomType.isActive} onChange={(value) => this.props.onChange({ value: value, name: 'isActive' })} name={`isActve`} disabled={loading} />
                            </HMS.FormWrapperInputComponent>
                        </div>
                        <div className="form-group col-md-6">
                            <HMS.FormWrapperInputComponent
                                isRequired={false}
                                isValidation={false}
                                labelTitle={i18n.t(`item.homestayRoomType.area`)}
                                visible={action !== DETAIL_ACTIONS.TRANSLATE}
                            >
                                <Input
                                    onChange={this.props.onChange}
                                    name={`area`}
                                    value={Func.formatMoney(Func.checkUndefine(homestayRoomType.area))}
                                    placeholder={i18n.t('item.homestayRoomType.area')} />

                            </HMS.FormWrapperInputComponent>
                        </div>
                        <div className="form-group col-md-6">
                            <HMS.FormWrapperInputComponent
                                isRequired={false}
                                isValidation={false}
                                labelTitle={i18n.t(`item.homestayRoomType.numberOfRoom`)}
                                visible={action !== DETAIL_ACTIONS.TRANSLATE}
                            >
                                <Input onChange={this.props.onChange} name={`numberOfRoom`} value={Func.formatMoney(Func.checkUndefine(homestayRoomType.numberOfRoom))} disabled={loading} placeholder={i18n.t('item.homestayRoomType.numberOfRoom')}/>
                            </HMS.FormWrapperInputComponent>
                        </div>
                        <div className="form-group col-md-6">
                            <HMS.FormWrapperInputComponent
                                isRequired={false}
                                isValidation={false}
                                labelTitle={i18n.t(`item.homestayRoomType.bedType`)}
                                visible={action !== DETAIL_ACTIONS.TRANSLATE}
                            >
                                <Input
                                    onChange={this.props.onChange}
                                    name={`bedType`}
                                    value={Func.checkUndefine(homestayRoomType.bedType)}
                                    placeholder={i18n.t('item.homestayRoomType.bedType')} />

                            </HMS.FormWrapperInputComponent>
                        </div>
                        <div className="form-group col-md-6">
                            <HMS.FormWrapperInputComponent
                                isRequired={false}
                                isValidation={false}
                                labelTitle={i18n.t(`item.homestayRoomType.maxAdult`)}
                                visible={action !== DETAIL_ACTIONS.TRANSLATE}
                            >
                                <Input onChange={this.props.onChange} name={`maxAdult`} value={Func.formatMoney(Func.checkUndefine(homestayRoomType.maxAdult))} disabled={loading} placeholder={i18n.t('item.homestayRoomType.maxAdult')}/>
                            </HMS.FormWrapperInputComponent>
                        </div>
                        <div className="form-group col-md-6">
                            <HMS.FormWrapperInputComponent
                                isRequired={false}
                                isValidation={false}
                                labelTitle={i18n.t(`item.homestayRoomType.maxChildren`)}
                                visible={action !== DETAIL_ACTIONS.TRANSLATE}
                            >
                                <Input onChange={this.props.onChange} name={`maxChild`} value={Func.formatMoney(Func.checkUndefine(homestayRoomType.maxChild))} disabled={loading} placeholder={i18n.t('item.homestayRoomType.maxChildren')}/>
                            </HMS.FormWrapperInputComponent>
                        </div> 
                        <Wrapper className="form-group col-md-12">
                            <HMS.FormWrapperInputComponent
                                labelTitle={i18n.t(`item.homestayRoomType.amenity`)}
                                visible={action !== DETAIL_ACTIONS.TRANSLATE}
                            >
                                <AntSelect className="select-types"
                                    showArrow
                                    mode="multiple"
                                    placeholder={Func.capitalizeFirstLetter((i18n.t('placeHolderForm.select') + " " + i18n.t("item.hotel.amenity")).toLowerCase())}
                                    value={dataAmenity}
                                    onChange={amenity => this.props.onChangeAmenity('amenity', amenity)}
                                    style={{ width: '100%' }}
                                    optionFilterProp="children"
                                >
                                    {(amenities || []).map(amenity => (
                                        amenity.isActive && <AntOption key={amenity.id} value={amenity.id}>
                                            {amenity.name}
                                        </AntOption>
                                    ))}
                                </AntSelect>
                            </HMS.FormWrapperInputComponent>
                        </Wrapper>
                        {/* <div className="form-group col-md-6">
                            <HMS.FormWrapperInputComponent
                                isRequired={false}
                                isValidation={false}
                                labelTitle={i18n.t(`item.homestayRoomType.square_unit`)}
                                visible={action !== DETAIL_ACTIONS.TRANSLATE}
                            >
                                <Input onChange={this.props.onChangeRoomFeatures} name={`square_unit`} value={Func.formatMoney(Func.checkUndefine(homestayRoomType.features.square_unit))} disabled={loading} placeholder={i18n.t('item.homestayRoomType.square_unit')}/>
                            </HMS.FormWrapperInputComponent>
                        </div>
                        <div className="form-group col-md-6">
                            <HMS.FormWrapperInputComponent
                                isRequired={false}
                                isValidation={false}
                                labelTitle={i18n.t(`item.homestayRoomType.square_unit_type`)}
                                visible={action !== DETAIL_ACTIONS.TRANSLATE}
                            >
                                <Input onChange={this.props.onChangeRoomFeatures} name={`square_unit_type`} value={homestayRoomType.features.square_unit_type} disabled={loading} placeholder={i18n.t('item.homestayRoomType.square_unit_type')}/>
                            </HMS.FormWrapperInputComponent>
                        </div> */}
                    </div>
                </div>
            </div>
        );
    }
}

